// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"cf692f81","769":"f7c1ba70"}[chunkId] + ".chunk.js";
};